import {
    IEquipeGerencia,
    IEquipeGerenciaCadastro,
} from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarUsuariosVinculadosServices(
    IDEquipeHelpDesk: number
) {
    return Service(
        Axios.get<Array<IEquipeGerenciaCadastro>>(
            `/helpdesk/gerenciaequipes/listarusuariosvinculados?IDEquipeHelpDesk=${IDEquipeHelpDesk}`
        )
    );
}

export async function ListarUsuariosDesvinculadosServices(
    IDEquipeHelpDesk: number
) {
    return Service(
        Axios.get(
            `/helpdesk/gerenciaequipes/listarusuariosdesvinculados?IDEquipeHelpDesk=${IDEquipeHelpDesk}`
        )
    );
}

export async function VincularUsuarioHelpdeskGerenciaServices(
    requestBody: IEquipeGerenciaCadastro
) {
    return Service(
        Axios.post(
            `/helpdesk/gerenciaequipes/vincularusuariogerencia`,
            requestBody
        )
    );
}

export async function DesvincularUsuarioHelpdeskGerenciaServices(
    ID_EQUIPE_GERENCIA: number
) {
    return Service(
        Axios.post(
            `/helpdesk/gerenciaequipes/desvincularusuariogerencia?ID_EQUIPE_GERENCIA=${ID_EQUIPE_GERENCIA}`
        )
    );
}

export async function ListarEquipesGerenciaServices() {
    return Service(
        Axios.get<Array<IEquipeGerencia>>(
            `/helpdesk/gerenciaequipes/listequipesgerencia`
        )
    );
}
